export const formStyles = {
  input: "w-full h-12 px-4 text-base bg-white border-2 border-slate-200 hover:border-purple-300 focus:border-purple-500 focus:outline-none rounded-lg shadow-sm transition-all duration-200 ease-in-out font-medium text-slate-900",
  label: "text-base font-semibold text-slate-700 mb-1.5",
  container: "space-y-4",
  fieldContainer: "space-y-2",
  errorText: "text-sm font-medium text-red-500 mt-1.5",
  icon: "absolute left-3.5 top-3.5 h-5 w-5 text-slate-400",
  popoverContent: "w-full p-0 border-2 border-slate-200 rounded-lg shadow-lg",
  button: "w-full h-12 px-4 text-base bg-white border-2 border-slate-200 hover:border-purple-300 focus:border-purple-500 focus:outline-none rounded-lg shadow-sm transition-all duration-200 ease-in-out font-medium text-slate-900 flex items-center justify-between",
  prefix: "inline-flex items-center px-4 h-12 text-base font-medium rounded-l-lg border-2 border-r-0 border-slate-200 bg-slate-50 text-slate-600",
};

export const cn = (...classes) => classes.filter(Boolean).join(' ');
